import { useEffect, useState } from "react";
import {
  fetchHospitolSetupStatus,
  subscribeSetupChange,
  type HospitolSetupStatus,
} from "./hospitol-setup-store";

export function useSetupStatus(): {
  status: HospitolSetupStatus | null;
  loading: boolean;
  refresh: () => void;
} {
  const [status, setStatus] = useState<HospitolSetupStatus | null>(null);
  const [loading, setLoading] = useState(true);

  const refresh = () => {
    setStatus(fetchHospitolSetupStatus());
    setLoading(false);
  };

  useEffect(() => {
    refresh();
    return subscribeSetupChange(refresh);
  }, []);

  return { status, loading, refresh };
}
